<template>
  <form-section id="distributor" :headline="this.$t('form.parties.distributor.headline')">
    <textfield
      id="distributor_name"
      :label="$t('form.parties.distributor.name.label')"
      :placeholder="$t('form.parties.distributor.name.placeholder')"
      v-model="distributor.name"
      isRequired
    />

    <div class="form-group">
      <label for="distributor_cvr">{{ $t('form.parties.distributor.cvr.label') }}</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="distributor_cvr"
          maxlength="8"
          minlength="8"
          :placeholder="$t('form.parties.distributor.cvr.placeholder')"
          v-model="distributor.cvr"
          @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
          @blur="validateRequired"
          required
        />
        <div class="invalid-feedback">
          <invalid-cross></invalid-cross>
          <span>{{ $t('form.shared.cvr_error') }}</span>
        </div>
      </div>
    </div>

    <textfield
      id="distributor_address"
      :label="$t('form.parties.distributor.address.label')"
      :placeholder="$t('form.parties.distributor.address.placeholder')"
      v-model="distributor.address"
      isRequired
    />

    <textfield
      id="distributor_zip_city"
      :label="$t('form.parties.distributor.zip_city.label')"
      :placeholder="$t('form.parties.distributor.zip_city.placeholder')"
      v-model="distributor.zipCity"
      isRequired
    />

    <textfield
      id="distributor_country"
      :label="$t('form.parties.distributor.country.label')"
      :placeholder="$t('form.parties.distributor.country.placeholder')"
      v-model="distributor.country"
      isRequired
    />
  </form-section>
</template>

<script>
import Textfield from "@/shared/components/Textfield.vue";
import FormSection from "@/shared/components/FormSection.vue";
export default {
  components: {
    Textfield,
    FormSection
  },
  data() {
    return {
      distributor: {
        name: "",
        cvr: "",
        address: "",
        zipCity: "",
        country: ""
      }
    };
  },
  watch: {
    distributor: {
      handler() {
        this.distributor.cvr = this.restrictNumber(this.distributor.cvr);
        this.$store.commit("updateDistributor", this.distributor);
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/form/parties/DistributorInput.vue